import React, { useRef } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { HubCardData } from '@/hooks/insights-hub/types';
import { HubCardType } from '@/types';
import { isHubCardType } from '@/utils/insights-hub';
import { LostItemSupportInfo } from './lost-item-support-info';
import { OverduePaymentSupportInfo } from './overdue-payment-support-info';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { useHover } from 'react-native-web-hooks';

interface Props {
  item: HubCardData;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}

export const SupportInfo: React.FC<Props> = ({ item, onPress, style }) => {
  const [styles] = useStyles();
  const supportInfoRef =
    useRef<React.ComponentRef<typeof TouchableOpacity>>(null);
  const isHovered = useHover(supportInfoRef);

  const getSupportInfo = (item: HubCardData) => {
    if (isHubCardType(item, HubCardType.OverduePayment)) {
      return (
        <OverduePaymentSupportInfo
          amount={item.amount}
          invoiceNumber={item.invoice_number}
        />
      );
    } else if (isHubCardType(item, HubCardType.LostItem)) {
      return (
        <LostItemSupportInfo
          displayName={item.display_name}
          externalID={item.external_item_id}
          packUnit={item.pack_unit}
          photoURLs={item.photo_url_list}
        />
      );
    } else if (isHubCardType(item, HubCardType.ChurnRisk)) {
      return null;
    }
    return null;
  };

  if (!getSupportInfo(item)) {
    return null;
  }

  return (
    <TouchableOpacity
      onPress={onPress}
      ref={supportInfoRef}
      style={[isHovered ? styles.hover : null, style]}
    >
      {getSupportInfo(item)}
    </TouchableOpacity>
  );
};

const useStyles = createStyles(() => ({
  hover: {
    opacity: 0.8,
  },
}));
